import React, {useContext} from 'react';
import classes from './buttonlang.module.scss'
import {Context} from "../../../context/Wrapper";
import {LANG_EN, LANG_ID} from "../../../constants";

const ButtonLang = (props) => {
    const context = useContext(Context)

    return (
        <>
            <div className={classes.Wrapper}>
                <div
                    onClick={() => props.change(LANG_EN)}
                    className={[context && context.locale === LANG_EN ? classes.Active : '', classes.Eng].join(' ')}>ENG</div>
                <div>|</div>
                <div onClick={() => props.change(LANG_ID)}
                    className={[context && context.locale !== LANG_EN ? classes.Active : '', classes.Id].join(' ')}>IND</div>
            </div>
        </>
    )
}

export default ButtonLang